<script setup>
import { computed } from 'vue';
import PostSaleStatusAnnotation from './PostSaleStatusAnnotation.vue';
import PostSaleStatusBankDocumentation from './PostSaleStatusBankDocumentation.vue';
import PostSaleStatusDeed from './PostSaleStatusDeed.vue';
import PostSaleStatusEngineering from './PostSaleStatusEngineering.vue';
import PostSaleStatusItbi from './PostSaleStatusItbi.vue';
import PostSaleStatusLaudemium from './PostSaleStatusLaudemium.vue';
import PostSaleStatusRegistry from './PostSaleStatusRegistry.vue';
import PostSaleStatusTaxes from './PostSaleStatusTaxes.vue';

const props = defineProps({
  event: { type: Object, required: true },
});

const statusComponents = {
  taxas: PostSaleStatusTaxes,
  itbi: PostSaleStatusItbi,
  banco_documentacao: PostSaleStatusBankDocumentation,
  engenharia: PostSaleStatusEngineering,
  averbacao: PostSaleStatusAnnotation,
  laudemio: PostSaleStatusLaudemium,
  escritura: PostSaleStatusDeed,
  registro: PostSaleStatusRegistry,
};

const statusComponent = computed(() => statusComponents[props.event.to_status]);
</script>

<template>
  <div>
    <component :is="statusComponent" v-if="statusComponent" :event="event" />
  </div>
</template>
